import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function resetPasswordFailure(draft: Draft<IAuthData>) {
  draft.resetPassword.config.isLoading = false;
}

export default resetPasswordFailure;
